import React, { useState, useCallback, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import Option from './TypeaheadOption';
import prepareHybridPlaces from './prepareHybridPlaces';

const TypeaheadOptionsContainer = ({ showItems, setShowItems, placeType, url }) => {
  const [places, setPlaces] = useState([]);

  const fetchPlaces = useCallback(() => {
    if (url !== '') {
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          setShowItems(true);
          setPlaces(data);
        });
    }
  }, [setShowItems, url]);

  useEffect(() => {
    fetchPlaces();
  }, [fetchPlaces]);

  const options = useMemo(() => prepareHybridPlaces(places, { placeType }), [places, placeType]);

  return (
    <ul
      className="typeahead"
      style={{
        display: showItems ? 'block' : 'none',
      }}
    >
      {options.length > 0 &&
        showItems &&
        options.map((option) => {
          return <Option key={option.slug} place={option} />;
        })}
    </ul>
  );
};

const propTypes = {
  placeType: PropTypes.oneOf(['terminal', 'city']),
  url: PropTypes.string.isRequired,
  showItems: PropTypes.bool.isRequired,
  setShowItems: PropTypes.func.isRequired,
};

const defaultProps = {
  placeType: null,
};

TypeaheadOptionsContainer.propTypes = propTypes;
TypeaheadOptionsContainer.defaultProps = defaultProps;
export default TypeaheadOptionsContainer;
